import React from "react";
import { Link } from '@reach/router'
import { Container, Button } from "@material-ui/core";
import ExistingVisualisations from "./components/ExistingVisualisations";
import "./style.css";

const CreateCartoMap = ({ id }) => {
  return (
    <div>
      <div className="carto-map-vis">
        <Container maxWidth="xl" className="white-card main-container">
          <h5 className="title">VISUALISATION</h5>
          <div className="main-sections-wrapper">
            <div>
              <p>
                Create a new Carto Map Visualization with all the Fences and Check-ins events.
              </p>
              <div className="important-notes">
                <h5>Important</h5>
                <ul>
                  <li>Data available only for the last 12 months</li>
                </ul>
              </div>
            </div>
            <div className="uploader-wrapper">
              <Link to="./create">
                <Button
                  variant="contained" 
                  color="primary" 
                  disableElevation
                >Create New Visualisation</Button>
              </Link>
            </div>
          </div>
        </Container>
        <ExistingVisualisations accountId={id} />
      </div>
    </div>
  );
};

export default CreateCartoMap;
